export const oxygenPlusConcentratorType = {
  oxygen: 'oxygen',
  oxygen_portable: 'oxygen_portable',
  oxygen_transportable: 'oxygen_transportable',
} as const;

export type OxygenPlusConcentratorType = typeof oxygenPlusConcentratorType[keyof typeof oxygenPlusConcentratorType];
